import axios from 'axios';

// Pubblicita': spesa delle piattaforme (Google Ads, Meta, ...), ROAS e impostazioni dei collegamenti
const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path) => `${context.rootGetters['settings/getUrl']}${path}`;

const actions = {
	// stessi parametri del periodo della Home (components/dashboard/filters.js filtersToParams)
	fetchReport: async (context, params) => (await axios.get(url(context, 'ads/report'), { ...auth(context), params })).data.data,
	fetchSettings: async context => (await axios.get(url(context, 'ads/settings'), auth(context))).data.data,
	saveSettings: async (context, data) => (await axios.put(url(context, 'ads/settings'), data, auth(context))).data.data,
	// lettura subito delle piattaforme (tutte o quelle indicate), in coda
	sync: async (context, sources = null) => (await axios.post(url(context, 'ads/sync'), { sources }, auth(context))).data.data,
};

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions,
};
